/* SneakerAsk-style product page enhancements - ABCD Fashion.
   Adds the pieces SneakerAsk has that this theme's product-template.liquid does
   not render: breadcrumb, share button, image colour swatches and per-size 48H
   badges. Reads data from the OlyxPdpData JSON block printed by
   templates/product.liquid. Every step is defensive - if the markup it expects
   is missing it simply does nothing rather than breaking the buy box. */
(function () {
  'use strict';

  function data() {
    var el = document.getElementById('OlyxPdpData');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var D = data();
  if (!D) return;

  var buyBox = document.querySelector('.OlyxPdp__BuyBox');
  var COLOR_WORDS = ['color', 'colour', 'couleur', 'kleur', 'farbe', 'colore'];

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* ---------- 1. Breadcrumb ------------------------------------------- */
  function breadcrumb() {
    if (document.querySelector('.OlyxCrumb')) return;
    var host = document.querySelector('.shopify-section[id*="product-template"]');
    if (!host) return;

    var parts = ['<a href="/">Home</a>'];
    if (D.collectionTitle && D.collectionUrl) {
      parts.push('<a href="' + D.collectionUrl + '">' + esc(D.collectionTitle) + '</a>');
    } else if (D.type) {
      parts.push('<a href="/collections/all">' + esc(D.type) + '</a>');
    }
    parts.push('<span>' + esc(D.title) + '</span>');

    var nav = el('nav', 'OlyxCrumb', parts.join('<i aria-hidden="true">|</i>'));
    nav.setAttribute('aria-label', 'Kruimelpad');
    host.insertBefore(nav, host.firstChild);
  }

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* ---------- 2. Share button ------------------------------------------ */
  function share() {
    if (!buyBox || document.querySelector('.OlyxShare')) return;
    var row = buyBox.querySelector('.OlyxPdp__RatingRow');
    if (!row) return;

    var btn = el('button', 'OlyxShare',
      '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M10 13V3M10 3 6.5 6.5M10 3l3.5 3.5"/><path d="M4 11v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-5"/></svg>');
    btn.type = 'button';
    btn.setAttribute('aria-label', abcdT('share_product', 'Deel dit product'));
    btn.addEventListener('click', function () {
      var url = location.origin + (D.url || location.pathname);
      if (navigator.share) {
        navigator.share({ title: D.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          btn.classList.add('is-copied');
          setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
        }, function () {});
      }
    });
    row.appendChild(btn);
  }

  /* ---------- 3. Image colour swatches --------------------------------- */
  /* The theme renders colour as another pill group. SneakerAsk shows image
     tiles instead, so map each colour value to the first variant image that
     uses it and repaint the buttons. The click handlers stay untouched. */
  function swatches() {
    if (!D.colorOption || !D.colorImages) return;

    var groups = document.querySelectorAll('.OlyxInline--generic, .OlyxInline--color');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var label = (group.textContent || '').toLowerCase();
      var isColor = false;
      for (var c = 0; c < COLOR_WORDS.length; c++) {
        if (label.indexOf(COLOR_WORDS[c]) === 0 || label.indexOf(COLOR_WORDS[c]) > -1) { isColor = true; break; }
      }
      if (!isColor) continue;

      group.classList.add('OlyxSwatchGroup');
      var btns = group.querySelectorAll('.OlyxSizeBtn');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        if (b.dataset.olyxSwatch) continue;
        var value = (b.dataset.value || b.textContent || '').trim();
        var img = D.colorImages[value];
        if (!img) continue;
        b.dataset.olyxSwatch = '1';
        b.setAttribute('title', value);
        b.style.backgroundImage = 'url(' + img + ')';
      }
    }
  }

  /* ---------- 4. Per-size 48H badge ------------------------------------ */
  function badges() {
    if (!D.has48h) return;
    var groups = document.querySelectorAll('.OlyxInline--size');
    for (var g = 0; g < groups.length; g++) {
      var btns = groups[g].querySelectorAll('.OlyxSizeBtn');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        if (b.querySelector('.OlyxSizeBadge') || b.disabled) continue;
        var badge = el('span', 'OlyxSizeBadge',
          '<svg viewBox="0 0 10 14" fill="currentColor" aria-hidden="true"><path d="M6 0 0 8h3.2L4 14l6-8H6.8z"/></svg>48H');
        b.appendChild(badge);
      }
    }
  }

  function run() {
    try { breadcrumb(); } catch (e) {}
    try { share(); } catch (e) {}
    try { swatches(); } catch (e) {}
    try { badges(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* the variant picker re-renders on selection, so re-apply after changes */
  document.addEventListener('variant:change', run);
  var mo = new MutationObserver(function () { try { swatches(); badges(); } catch (e) {} });
  var form = document.querySelector('.ProductForm');
  if (form) mo.observe(form, { childList: true, subtree: true });
})();
